import { initSentry } from "@/global/lib/sentry";

export const initLibs = () => {
  initSentry();
};
